
import { jsPDF } from 'jspdf';

import { ARIAL_NORMAL } from './fonts';

const STYLES = {
    container: `
        font-family: arial;
        font-size: 30px;
        padding: 100px;
        `,
    header: `
        font-size: 100px;
        width: 1800px;
        padding-top: 30px;
        padding-bottom: 30px;
        padding-left: 0px;
        `,
    map: `
        width: 1900px;
        `,
    mapContainer: `
        width: 1900px;
        border: 1px solid #999999;
        `,
    summary: `
        font-size: 80px;
        width: 1800px;
        padding-top: 60px;
        padding-bottom: 30px;
        padding-left: 0px;
        `,
    table: `
        `,
    row: `
        display: flex;
        flex-direction: row;
        width: 1900px;
        `,
    cellHeader: `
        font-weight: 800;
        border: 2px solid #999999;
        padding: 10px;
        `,
    cellBody: `
        border: 1px solid #999999;
        padding: 10px;
        `,
    title: `
        width: 1200px;
        `,
    quantity: `
        width: 300px;
        text-align: right;
        `,
    price: `
        width: 400px;
        text-align: right;
        `,
    priceAll: `
        font-size: 50px;
        width: 1900px;
        padding: 30px;
        padding-left: 0px;
        `,
};

function callAddFont() {
    this.addFileToVFS('arial-normal.ttf', ARIAL_NORMAL);
    this.addFont('arial-normal.ttf', 'arial', 'normal');
};


function generateHtmlMap(html, mapContent) {
    html.push(
        `
        <div style="${STYLES.mapContainer}">
            <img style="${STYLES.map}" src=${mapContent.content} />
        </div>
        `
    );
}

function generateHtmlPriceAll(html, summary) {
    html.push(
        `
        <div style="${STYLES.priceAll}">
        Celkem cena: ${new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(summary.price)}
        </div>
        `
    );
}

function generateHtmlSummary(html, summary) {
    html.push(`<div style="${STYLES.summary}">Sumarizace</div>`);
    html.push(`<div style="${STYLES.table}">`);

    html.push(
        `
        <div style="${STYLES.row}">
            <div style="${STYLES.title} ${STYLES.cellHeader}">Operace</div>
            <div style="${STYLES.quantity} ${STYLES.cellHeader}">Množství</div>
            <div style="${STYLES.price} ${STYLES.cellHeader}">Cena</div>
        </div>
        `
    );

    summary.operationItems.forEach(item => {
        let unit = (item.mj === 'm2') ? 'm²' : 'm³';

        html.push(
            `
            <div style="${STYLES.row}">
                <div style="${STYLES.title} ${STYLES.cellBody}">${item.title}</div>
                <div style="${STYLES.quantity} ${STYLES.cellBody}">
                    ${new Intl.NumberFormat('cs-CZ').format(item.quantity)} ${unit}
                </div>
                <div style="${STYLES.price} ${STYLES.cellBody}">
                    ${new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK' }).format(item.quantity * item.price)}
                </div>
            </div>
            `
        );
    });
    html.push('</div>');
}

function generateHtmlTitle(html) {
    html.push(`<div style="${STYLES.header}">KALKULACE MEZÍ</div>`);
}

function generateHtml(mapContent, summary) {
    let html = [];

    html.push(`<div style="${STYLES.container}">`);

    generateHtmlTitle(html);
    generateHtmlMap(html, mapContent)
    generateHtmlSummary(html, summary)
    generateHtmlPriceAll(html, summary)

    html.push('</div>');

    return html.join('');
}

export default function generateCalculationPdf(mapContent, summary, callbackDone) {
    const PAGE_OPTIONS = {
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
    };

    jsPDF.API.events.push(['addFonts', callAddFont])
    let pdf = new jsPDF(PAGE_OPTIONS);

    pdf.html(
        generateHtml(mapContent, summary),
        {
            callback: (doc) => {
                if (callbackDone) {
                    callbackDone(doc);
                }
            },
            html2canvas: {
                scale: 0.1
            },
            y: 0,
            width: 180
        }
    );
}
